/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_dot_pitch = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dot pitch`)
};

const es_ppi_dot_pitch = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paso de píxel`)
};

const de_ppi_dot_pitch = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pixelabstand`)
};

const nl_ppi_dot_pitch = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dot pitch`)
};

const fr_ppi_dot_pitch = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de masque`)
};

const it_ppi_dot_pitch = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dot pitch`)
};

const pt_br2_ppi_dot_pitch = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dot pitch`)
};

const pt_ppi_dot_pitch = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pitch de píxel`)
};

const ja_ppi_dot_pitch = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドットピッチ`)
};

const zh_ppi_dot_pitch = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点距`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_dot_pitch = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_dot_pitch(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_dot_pitch", locale)
	if (locale === "en") return en_ppi_dot_pitch(inputs)
	if (locale === "es") return es_ppi_dot_pitch(inputs)
	if (locale === "de") return de_ppi_dot_pitch(inputs)
	if (locale === "nl") return nl_ppi_dot_pitch(inputs)
	if (locale === "fr") return fr_ppi_dot_pitch(inputs)
	if (locale === "it") return it_ppi_dot_pitch(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_dot_pitch(inputs)
	if (locale === "pt") return pt_ppi_dot_pitch(inputs)
	if (locale === "ja") return ja_ppi_dot_pitch(inputs)
	return zh_ppi_dot_pitch(inputs)
};